"use client";

import React from "react";
import { Card } from "react-bootstrap";

interface BillingDetailsProps {
  order: any;
}

const BillingDetails = ({ order }: BillingDetailsProps) => {
  return (
    <>
      <Card className="bg-white border-0 rounded-3 mb-4">
        <Card.Body className="p-4">
          <h3 className="mb-3">Detalles de Facturación</h3>

          <div className="d-flex align-items-center mb-2">
            <span className="text-secondary">Nombre:</span>
            <span className="ms-1">{order?.user_id?.name}</span>
          </div>

          <div className="d-flex align-items-center mb-2">
            <span className="text-secondary">Email:</span>
            <span className="ms-1">{order?.user_id?.email}</span>
          </div>

          {order?.siigo_invoice?.public_url && (
            <div className="mt-4">
              <button
                className="btn btn-info w-100 d-flex align-items-center justify-content-center gap-2"
                onClick={() => window.open(order.siigo_invoice?.public_url, '_blank')}
              >
                <span className="material-symbols-outlined fs-20">
                  description
                </span>
                Ver Factura Electrónica
              </button>
            </div>
          )}

        </Card.Body>
      </Card>
    </>
  );
};

export default BillingDetails;
